'use strict';

var $ = require('jquery');
var Debouncer = require('../lib/Debouncer.js');

function ScrollSpy(config) {
	this.config = $.extend({}, {
		component: 'scrollSpy',
		trigger: 'scrollSpy__trigger',
		heading: 'scrollSpy__heading',
		activeClass: 'scrollSpy__heading--active',
		percentInView: 0
	}, config);
}

ScrollSpy.prototype.build = function() {
	var that = this;

	this.areas = [];
	$('.' + this.config.trigger).each(function(index, element) {
		that.areas.push({
			position: $(element).offset().top -
				$(window).height() * (that.config.percentInView / 100),
			item: $(element),
			heading: $('.' + that.config.heading).eq(index)
		});
	});
}

ScrollSpy.prototype.activate = function() {
	var that = this;
	
	this.build();
	var resizeDebouncer = new Debouncer(function() {
		that.build();
		that.attachHandler();
		that.activateCurrentBasedOnScroll();
	});
	window.addEventListener('resize', resizeDebouncer.run, false);

	this.attachHandler(this.areas);
	this.setEnabled(true);
};

ScrollSpy.prototype.deactivate = function() {
	this.detachHandler();
}

ScrollSpy.prototype.setEnabled = function(enabled) {
	this.enabled = enabled;
	if (enabled) {
		this.activateCurrentBasedOnScroll();
	}
}

ScrollSpy.prototype.attachHandler = function(areas) {
	var that = this;

	$(window).on('scroll.' + that.config.component, function() {
		if (!that.enabled) {
			// Currently disabled
			return;
		}

		that.activateCurrentBasedOnScroll();
	});
}

ScrollSpy.prototype.activateCurrentBasedOnScroll = function() {
	var scrollTop = $(window).scrollTop();

	if (scrollTop < this.areas[0].position) {
		$('.' + this.config.activeClass).removeClass(this.config.activeClass);
		this.currentIndex = -1;
	} else {
		for (var i = 0; i < this.areas.length; i++) {
			if (scrollTop >= this.areas[i].position) {
				this.currentIndex = i;
			} else {
				break;
			}
		}

		$('.' + this.config.activeClass).removeClass(this.config.activeClass);
		if (this.currentIndex >= 0) {
			this.areas[this.currentIndex].heading.addClass(this.config.activeClass);
			this.areas[this.currentIndex].item.addClass(this.config.activeClass);
		}
	}
}

ScrollSpy.prototype.detachHandler = function() {
	$(window).off('scroll.' + that.config.component);
}

module.exports = ScrollSpy;
